import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const RoleTableDataAPI = createAsyncThunk("RoleTableData", async ({ data }) => {
    const {
        M_RoleID,
        RoleName,
        Role,
        M_ProjectTypeID,
        M_UsersID,
        token,
        From,
        To,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_M_Role_Select?M_RoleID=${M_RoleID}&M_ProjectTypeID=${M_ProjectTypeID}&Role=${Role}&M_UserID=${M_UsersID}&FromTop=${From}&ToTop=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const RoleTableDataSlice = createSlice({
    name: "RoleTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoleTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoleTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RoleTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const RoleTableDataReducer = RoleTableDataSlice.reducer


export const RolePostDataAPI = createAsyncThunk("RolePostData", async ({ data }) => {
    const {
        M_RoleID,
        M_ProjectTypeID,
        Role,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleOnCloseClick
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_RoleID", M_RoleID);
    formdata.append("M_ProjectTypeID", M_ProjectTypeID);
    formdata.append("Role", Role);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_M_Role_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const RolePostDataSlice = createSlice({
    name: "RolePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RolePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RolePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(RolePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const RolePostDataReducer = RolePostDataSlice.reducer

// -----------------Delete API ---------------

export const RoleDeleteAPI = createAsyncThunk("RoleDelete", async ({ data }) => {
    const {
        M_RoleID,
        M_UserID,
        token,
        Flag,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_RoleID", M_RoleID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_M_Role_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const RoleDeleteSlice = createSlice({
    name: "RoleDelete",
    initialState: {
        isDeleteLoading: false,
        RoletableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoleDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(RoleDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.RoletableData = action.payload;

        });
        builder.addCase(RoleDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.RoletableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const RoleDeleteReducer = RoleDeleteSlice.reducer